import { FETCH_HL7_QUEUE_ERROR, FETCH_HL7_QUEUE_START, FETCH_HL7_QUEUE_SUCCESS, CLOSE_ACKNOWLEDGEMENT_MODAL, SHOW_ACKNOWLEDGEMENT_MODAL } from '../../actions/admin/hl7QueueAction';

const INIT_STATE = {
    error: "",
    message: '',
    loading: false,
    sending: false,
    showModal: false,
    selectedRow: null,
    hl7Queue: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
};

const hl7QueueReducer = (state = INIT_STATE, action) => {
    let index;
    let newState;
    switch (action.type) {
        case FETCH_HL7_QUEUE_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_HL7_QUEUE_SUCCESS: {

            return { ...state, error: '', message: '', loading: false, ...action.data };
        }
        case FETCH_HL7_QUEUE_ERROR: {
            return { ...INIT_STATE };
        }
        case SHOW_ACKNOWLEDGEMENT_MODAL: {
            return { ...state, showModal: true, selectedRow: action.selectedRow };
        }
        case CLOSE_ACKNOWLEDGEMENT_MODAL: {
            return { ...state, showModal: false, selectedRow: null };
        }

        default:
            return state;
    }
}

export default hl7QueueReducer;
